/*eslint-disable */
const $ = window.jQuery = require('jquery');

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import addReserachGroup from './add-research-group';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';
import updateReserachGroup from './update-research-group-detail';

export default {
  name: 'research-group-list',
  components: {
    'pp-left-sidebar' : ppLeftSidebar,
    'add-reserach-group' : addReserachGroup,
    'update-reserach-group' : updateReserachGroup,
    'access-feature-of-blurb' : accessFeaturesForBlurb
  },
  props: [],
  data () {
    return {
      researchGroupList:null,
      researchGroupListResults:[],
      nextSteper:'',
      nextPageUrl:'',
      addResearchGroupPopupState:false,
      updateResearchGroupPopupState:false,
      updateResearchGroupPopupId:'',
      removeRGroupPopupState:false,
      removeRGroupPopupId:'',
      selfUserInfo:null,
      accessFeaturesOfPackageState:false
    }
  },
  computed: {
    ...mapGetters([
      'getResearchGroupForAwerackGetters',
      'acUserDetailsStateGetters',
    ]),
    getSelfUserInfo(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    getResearchGroupDetails(){
      this.researchGroupList = this.$store.getters.getResearchGroupForAwerackGetters.data;
      return
    },
    getResearchGroupResultsIntialsState(){
      if(this.researchGroupList){
        this.nextPageUrl = this.researchGroupList.next
        this.nextSteper = this.researchGroupList.next
        this.researchGroupListResults = [].concat(this.researchGroupList.results)
      }
    }
  },
  mounted () {
    this.getSelfUserInfo
    bus.$on('addResearchGroupPopupStateBus', (data) => {
      this.addResearchGroupPopupState = data;
    });
    bus.$on('updateResearchGroupPopupStateBus', (data) => {
      this.updateResearchGroupPopupState = data;
    });
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
  },
  methods: {
    accessFeaturesOfPackagemethod(){
      this.accessFeaturesOfPackageState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    getResearchGroupListAgain(){
      this.$store.dispatch('getResearchGroupListFun')
    },
    openPopupOfAddResearchGroup(){
      this.addResearchGroupPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updateAwerackRGroupInfoMethod(itemId){
      this.updateResearchGroupPopupState = true
      this.updateResearchGroupPopupId = itemId
      $('body').addClass('body_right_scroll_remove')
    },
    removeRGroupMethod(itemId){
      this.removeRGroupPopupState = true
      this.removeRGroupPopupId = itemId
      $('body').addClass('body_right_scroll_remove')
    },
    removeConfirmRGroupMethod(){
      this.$store.dispatch('removeAwerackPaperFun',{id:this.removeRGroupPopupId}).then((res)=>{
        toast.success(res.data.msg);
        this.closeRemoveRGroupMethod()
        this.getResearchGroupListAgain()
      }).catch((err)=>{
      })
    },
    closeRemoveRGroupMethod(){
      this.removeRGroupPopupState = false
      this.removeRGroupPopupId = ''
      $('body').removeClass('body_right_scroll_remove')
    }
  },
  watch:{
    getSelfUserInfo(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
    getResearchGroupDetails(){
      return this.$store.getters.getResearchGroupForAwerackGetters
    },
    getResearchGroupResultsIntialsState(){
      if(this.researchGroupList){
        this.nextPageUrl = this.researchGroupList.next
        this.researchGroupListResults = [].concat(this.researchGroupList.results)
      }
    },
    nextSteper(old_val, new_val){
      if(old_val != ''){
        this.nextPageUrl = old_val
      }
    },
  },
  beforeCreate:function(){
    $('body').addClass('researchfile_body_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'paperPilesPreferences' && to.name != 'paperPiles' && to.name != 'bucketDetails'){
      $('body').removeClass('researchfile_body_wrp');
    }
    next();
  },
}